const VACCINE_BASE_COLORS = [
  '#2772C0', '#28C76F', '#FF9F43', '#EA5455', '#7367F0',
  '#00CFE8', '#A855F7', '#F97316', '#10B981', '#EF4444',
  '#6366F1', '#14B8A6', '#F59E0B', '#EC4899', '#8B5CF6',
  '#06B6D4', '#84CC16', '#E11D48', '#0EA5E9', '#D946EF',
  '#22C55E', '#F43F5E', '#3B82F6', '#FBBF24', '#A78BFA',
]

export default {
  methods: {
    generateColors(count) {
      const colors = []

      for (let i = 0; i < count; i += 1) {
        colors.push(VACCINE_BASE_COLORS[i % VACCINE_BASE_COLORS.length])
      }

      return colors
    },

    buildVaccineColorMap(referenceList) {
      const map = {}

      if (!Array.isArray(referenceList)) {
        return map
      }

      referenceList.forEach((item, index) => {
        const idVacina = Number(item && item.id_vacina)

        if (!idVacina) {
          return
        }

        map[idVacina] = VACCINE_BASE_COLORS[index % VACCINE_BASE_COLORS.length]
      })

      return map
    },
  },
}

export { VACCINE_BASE_COLORS }
